import { Injectable } from "@angular/core";
import { FileItem, TransferItem } from "../models";
import { ActivatedRoute, NavigationEnd, Router } from "@angular/router";
import { FileItemService } from "../../file/file-item.service";
import { filter } from 'rxjs';
import * as LinkFileListActions from "../../actions/link-file-list.actions";
import { Store } from "@ngrx/store";
import * as fromRoot from "../../reducers";
const SYNC_ID_QUERY_PARAM = 'sync_id';
@Injectable({ providedIn: 'root' })
export class TransferWidgetNavigationService {
    private cacheKey: string | null = null;
    constructor(private router: Router, private route: ActivatedRoute, private fileItemService: FileItemService,  private store: Store<fromRoot.State>,) {
        
        const url = this.router.url;
        const matches = url.match(/\/dl\/([^?#]+)/);
        this.cacheKey = matches ? matches[1] : null;
     
        this.router.events.pipe(
            filter(event => event instanceof NavigationEnd)
        ).subscribe((event: NavigationEnd) => {
            const urlMatches = event.url.match(/\/dl\/([^?#]+)/);
            const newCacheKey = urlMatches ? urlMatches[1] : null;
            this.cacheKey = newCacheKey;
        });
    }
    
    public checkIsCurrentRoute(item: FileItem, linkData: any): boolean {
        if (!linkData?.commands?.length) {
            return false;
        }

        const currentUrl = this.router.url;
        const targetUrl = this.router.createUrlTree(
            linkData.commands,
            linkData.extras
        ).toString();

        return currentUrl === targetUrl;
    }

    public previewItem = async (item: FileItem | TransferItem, compat: any, isBusiness: number) => {
        const transferItem  = (item as unknown as TransferItem)
        
        // duck typing to check if item is a TransferItem
        if (!!transferItem.filename){
            item = this.transformTransferItemToFileItem(transferItem);
        }

        await this.previewFileItem(item as unknown as FileItem, compat, isBusiness);
    }
    
    public transformTransferItemToFileItem(item: TransferItem): FileItem {
        const transferItem  = (item as unknown as TransferItem)
        // TODO check mapping
        item = {...item,
            name: transferItem.filename,
            type: transferItem.mimetype || transferItem.fileobj.type,
            filetype: {mimetype: transferItem.fileobj.type},
            pid: transferItem.sync_pid
        } as any;
        return item as unknown as FileItem
    }
    
    private async previewFileItem(item: FileItem, compat: any, isBusiness: number){
        const syncIdQueryParam = this.route.snapshot.queryParams[SYNC_ID_QUERY_PARAM];
        item = item as unknown as FileItem;
        let { commands, extras } = this.getItemLink(item, compat, isBusiness);
      
        const isCurrentRoute = this.checkIsCurrentRoute(item, { commands, extras });
        if (isCurrentRoute){
            return;
        }
        const isDirectoryChange = item.pid !== syncIdQueryParam;
        if (isDirectoryChange) {
            this.store.dispatch(new LinkFileListActions.ChangeDirAction(item.pid));
        }
        await this.router.navigate(commands, {...extras});
    }
    
    private decorateFragment(compat: any): { fragment: string } | undefined {
        if (!compat || this.route.snapshot.fragment) {
            return { fragment : this.route.snapshot.fragment };
        }
    }
    
    private getItemType(item: FileItem, compat: any, isBusiness: number): string {
        if (this.fileItemService.isImage(item)) { return 'image'; }
        if (this.fileItemService.isText(item)) { return 'text'; }
        if (this.fileItemService.isAudio(item)) { return 'audio'; }
        if (this.fileItemService.isVideo(item)) { return 'video'; }

        if (!compat) { return 'default'; }

        if (this.fileItemService.isPDF(item)) {
            if (item.size > this.fileItemService.MAX_PREVIEW_SIZE_PDF && item.previewonly && !isBusiness) {
                return 'pdf';
            } else if (item.size <= this.fileItemService.MAX_PREVIEW_SIZE_PDF || isBusiness) {
                return 'doc';
            }
        } else if (isBusiness && this.fileItemService.isDocument(item)) {
            return 'doc';
        }

        return 'default';
    }

    private getItemLink = (item: FileItem, compat: any, isBusiness: number) => {
        const type = this.getItemType(item, compat, isBusiness);

        let queryParams = { sync_id: item.pid };
        let fragment = this.decorateFragment(compat)?.fragment;
        const defaultItemLink =  { commands: [], extras: { queryParams: undefined, fragment: undefined } };
        
        const cacheKey = item.linkID;
        if (!cacheKey) return defaultItemLink;
        
        if (this.router.url.includes('/dl')) {
            const navigationParams = ['/dl', cacheKey, 'view', type, item.sync_id];
            if (this.route.snapshot.params['key']) {
                navigationParams.splice(2, 0, this.route.snapshot.params['key']);
            }
            return {
                commands: navigationParams,
                extras: {
                    queryParams: queryParams,
                    fragment: fragment
                }
            };
        } else if (this.router.url.includes('/al')) {
            const navigationParams = ['al', cacheKey];
            return {
                commands: navigationParams,
                extras: {
                    queryParams: undefined,
                    fragment: fragment
                }
            };
        }
        return defaultItemLink
    }

    public async changeDirectoryForLinkFileItem(item: TransferItem, id: number, compat: any): Promise<void> {
        this.store.dispatch(new LinkFileListActions.ChangeDirAction(id));
        const cacheKey =  item.linkID;
        if (!cacheKey) return;
        await this.router.navigate(['/dl', cacheKey], {
                queryParams: { sync_id: id },
                ...this.decorateFragment(compat),
                replaceUrl: true
            });
    }
}